import {useMediaQuery} from "@mui/material";
import React, {PropsWithChildren, useEffect, useState} from "react";
import theme from "./theme";
import {Route, Routes, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {PaperBackdrop} from "./Components/SamaggiBackdrop";
import {checkToken} from "./support";
import {Store} from "./Store/Store";
import {SignIn} from "./Auth/SignIn";
import {Callback} from "./Auth/Callback";

export interface BasicProps {
    mobile: boolean,
    vertical: boolean,
    setShowCover: React.Dispatch<React.SetStateAction<boolean>>
}

export const Main: React.FC< PropsWithChildren > = () => {
    const mobile = useMediaQuery(theme.breakpoints.down("md"));
    const vertical = useMediaQuery(theme.breakpoints.down("sm"));
    const location = useLocation();
    const navigate = useNavigate();
    const [params, ] = useSearchParams();

    const [showCover, setShowCover] = useState(false);

    useEffect(() => {
        doTokenCheck();
    }, [location]);

    useEffect(() => {
        console.log("Added event listener.")

        window.addEventListener("storage", () => {
            const token = localStorage.getItem("token");
            console.log("UPDATED!", token, location.pathname)
            if (location.pathname !== "/callback" && token !== null) {
                setShowCover(true);
                doTokenCheck()
            } else if (location.pathname === "/sign-in" && token === null) {
                setShowCover(false);
            }
        }) // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function doTokenCheck() {
        checkToken().then((valid) => {
            console.log("DO TOKEN CHECK", valid, location.search)
            // setShowCover(false);
            if (!valid && !["/sign-in", "/sign-in/", "/callback"].includes(location.pathname)) {
                const url = new URL(window.location.protocol + '//' + window.location.host + "/sign-in")

                if (location.pathname !== "/") {
                    url.searchParams.set("nav", location.pathname);
                }

                params.forEach((value, key) => {
                    if (key !== "nav" && key !== "req") {
                        url.searchParams.set(key, value);
                    }
                })

                window.location.href = url.href;
            } else if (valid && location.pathname === "/sign-in") {
                if (params.has("nav")) {
                    const cleanedParams = params;
                    const nav = (params.get("nav") as string).replace("$", "/");
                    cleanedParams.delete("nav");

                    console.log("NAV1")

                    navigate({
                        pathname: nav,
                        search: cleanedParams.toString()
                    });
                } else {
                    console.log("NAV2")

                    navigate({
                        pathname: "/",
                        search: params.toString()
                    });
                }
            } else if (!valid && !["/sign-in", "/callback"].includes(location.pathname)) {
                console.log("NAV3", location.pathname)
                navigate("/sign-in")
            }
        })
    }

    return (
        <div style={{width: "95%", alignSelf: "center", marginLeft: "auto", marginRight: "auto", height: "100%"}}>
            <PaperBackdrop open={showCover} style={{height: "100%"}}>
                <Routes>
                    <Route path="/sign-in" element={<SignIn mobile={false} vertical={false} setShowCover={setShowCover}/>}/>
                    <Route path="/callback" element={<Callback mobile={false} vertical={false} setShowCover={setShowCover}/>}/>
                    <Route path="/:store" element={<Store mobile={false} vertical={false} setShowCover={setShowCover}/>}/>
                    <Route path="/" element={<Store mobile={false} vertical={false} setShowCover={setShowCover}/>}/>
                </Routes>
            </PaperBackdrop>
        </div>
    )
}
